import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { isUserVip } from "../vip/isUserVip";
import {
  getReplyPreviewText,
  getReplySender,
  getReplySenderName,
} from "./chatReplyUtils";
import "./chatReply.scss";

const ChatReplyQuote = ({
  replyTo,
  senderField = "sender",
  onJump,
  className = "",
}) => {
  const { t } = useTranslation("common");
  if (!replyTo) return null;

  const isDeleted = Boolean(replyTo.isDeleted);
  const canJump = Boolean(onJump) && !isDeleted;
  const quotedSender = getReplySender(replyTo, senderField);
  const isQuotedVip = isUserVip(quotedSender);
  const name =
    getReplySenderName(replyTo, senderField) ||
    t("one_to_one.reply") ||
    "Reply";

  return (
    <button
      type="button"
      className={`chat-reply-quote${isDeleted ? " is-deleted" : ""}${!canJump ? " is-static" : ""}${isQuotedVip ? " is-vip" : ""} ${className}`.trim()}
      disabled={!canJump}
      onClick={(e) => {
        e.stopPropagation();
        if (canJump) onJump(replyTo);
      }}
    >
      <span className="chat-reply-quote-name">{name}</span>
      <span className="chat-reply-quote-text">
        {getReplyPreviewText(replyTo, t)}
      </span>
    </button>
  );
};

ChatReplyQuote.propTypes = {
  replyTo: PropTypes.object,
  senderField: PropTypes.oneOf(["msgByUserId", "sender"]),
  onJump: PropTypes.func,
  className: PropTypes.string,
};

export default ChatReplyQuote;
